export default __webpack_public_path__ + "media/images/images/flags/wy-4ce869a39a77d7dedaec8d9c0215fd58.png";